module.exports = __webpack_public_path__ + "img/w1-b2.8eaa10f5.jpg";